import React from 'react';

import Button from '@atlaskit/button';

import { useFeedbackDispatch } from '../Feedback.reducer';
import {
  ActionsWrapperStyled,
  HeaderWrapperStyled,
  ScreenStyled,
} from './Screens.styled';

const openMarketplacePage = () => {
  window.open(
    'https://marketplace.atlassian.com/apps/1222083/qality-test-management-for-jira?hosting=cloud&tab=reviews',
    '_blank'
  );
};

export default function GoToMarketplaceScreen(): JSX.Element {
  const dispatch = useFeedbackDispatch();

  const handleButtonClick = () => {
    openMarketplacePage();
    dispatch({
      type: 'click-write-a-review-on-marketplace',
    });
  };

  return (
    <ScreenStyled>
      <HeaderWrapperStyled>
        <h5>Thanks! Share your opinion.</h5>
        <div>Write a review on Marketplace and help others find our app.</div>
      </HeaderWrapperStyled>
      <ActionsWrapperStyled justifyContent='center'>
        <Button appearance='primary' onClick={handleButtonClick}>
          Write a review on Marketplace
        </Button>
      </ActionsWrapperStyled>
    </ScreenStyled>
  );
}
